/**
 * src/config.js
 * تنظیمات جامع پروژه فرزانه (Frontend)
 */

const backendBaseUrl = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

// 1. BASE_API_URL: آدرس پایه برای تمام درخواست‌های API
// در حالت توسعه، اگر از Proxy استفاده می‌کنید، نیازی به دامنه نیست.
export const BASE_API_URL = backendBaseUrl
  ? `${backendBaseUrl}/api/v1`
  : "/api/v1";
export const AUTH_BASE_URL = `${BASE_API_URL}/auth`; // مسیر اختصاصی برای لاگین و ثبت‌نام
// 2. MEDIA_BASE_URL: آدرس پایه برای فایل‌های رسانه‌ای
export const MEDIA_BASE_URL = backendBaseUrl || "http://localhost:8000";

// ----------------------------------------------------------------------
// 🔧 تنظیمات عمومی و محیطی
// ----------------------------------------------------------------------

export const NODE_ENV = process.env.NODE_ENV || 'development';
export const IS_DEVELOPMENT = NODE_ENV === 'development';
export const IS_PRODUCTION = NODE_ENV === 'production';

export const API_TIMEOUT = parseInt(process.env.REACT_APP_API_TIMEOUT) || 15000;
export const APP_NAME = 'فرزانه';
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';

// ----------------------------------------------------------------------
// 🚀 تنظیمات ویژگی‌ها و UI
// ----------------------------------------------------------------------

export const FEATURES = {
    REMEMBER_ME: true,
    PASSWORD_RESET: true,
    EMAIL_AUTH: true,
    PHONE_AUTH: true,
    SOCIAL_LOGIN: false,
    FILE_UPLOAD: true,
    REAL_TIME_NOTIFICATIONS: false,
};

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

export const UI = {
    ITEMS_PER_PAGE: 12,
    SEARCH_DEBOUNCE_MS: 300,
    TOAST_DURATION: 5000,
};

// ----------------------------------------------------------------------
// 🎯 توابع کمکی (Helper Functions) - کاملاً ایمن شده
// ----------------------------------------------------------------------

/**
 * دریافت آدرس کامل مدیا با مدیریت صحیح اسلش‌ها
 */
export const getAuthUrl = (endpoint) => {
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    return `${AUTH_BASE_URL}/${cleanEndpoint}`;
};
export const getMediaUrl = (filePath) => {
    if (!filePath) return null;
    if (filePath.startsWith('http')) return filePath;
    
    const cleanPath = filePath.startsWith('/') ? filePath.slice(1) : filePath;
    return `${MEDIA_BASE_URL}/${cleanPath}`;
};

/**
 * دریافت آدرس کامل API با مدیریت صحیح اسلش‌ها
 */
export const getApiUrl = (endpoint) => {
    if (!endpoint) return BASE_API_URL;
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    return `${BASE_API_URL}/${cleanEndpoint}`;
};

// ----------------------------------------------------------------------
// 📦 Export Default
// ----------------------------------------------------------------------

const config = {
    BASE_API_URL,
    MEDIA_BASE_URL,
    NODE_ENV,
    IS_DEVELOPMENT,
    IS_PRODUCTION,
    API_TIMEOUT,
    APP_NAME,
    APP_VERSION,
    FEATURES,
    MAX_FILE_SIZE,
    ALLOWED_IMAGE_TYPES,
    UI,
    getMediaUrl,
    getApiUrl,
};

export default config;